// extracted by mini-css-extract-plugin
module.exports = {"feedLayout":"page_feedLayout__whLye","pageContainer":"page_pageContainer__4Xdyz"};